import React from "react";
import { Link } from "react-router-dom";
import SectionTitle from "../../components/SectionTitle";
import Button from "../../components/Button";

import aboutImg1 from "../../assets/img/about/about-4-1.jpg";
import aboutImg2 from "../../assets/img/about/about-4-2.jpg";
import shapeImg1 from "../../assets/img/about/shape-4-2.png";
import shapeImg2 from "../../assets/img/about/shape-4-1.png";

const About = () => {
  return (
    <div
      id="it-about"
      className="it-about-2-area it-about-style-2 p-relative pt-120 pb-120"
    >
      <div className="container">
        <div className="row align-items-center">
          <div
            className="col-xl-6 col-lg-6 order-1 order-lg-0 wow animate__fadeInLeft"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <div className="it-about-4-left p-relative">
              <div className="it-about-4-thumb-1">
                <img src={aboutImg1} alt="" />
              </div>

              <div className="it-about-4-shape-1 d-none d-lg-block">
                <img src={shapeImg1} alt="" />
              </div>
              <div className="it-about-4-shape-2 d-none d-lg-block">
                <img src={shapeImg2} alt="" />
              </div>
            </div>
          </div>
          <div
            className="col-xl-6 col-lg-6 order-0 order-lg-1 wow animate__fadeInRight"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <div className="it-about-2-right">
              <div className="it-about-2-content">
                <SectionTitle
                  itemClass="it-about-2-title-box mb-20"
                  subTitleClass="it-section-subtitle green"
                  subTitle="About us"
                  titleClass="it-section-title"
                  title="We are here to help you"
                />
                <span>
                  Carolyn Moore, FNP Board-Certified Family Nurse Practitioner
                  Owner Carolyn Moore is a Board-Certified Family Nurse
                  Practitioner through the American Nursing Credentialing Center
                  (ANCC). She graduated with her Bachelor's in Nursing in 2005
                  and Master's in Nursing in 2014, both obtained at University
                  of Colorado at Colorado Springs. She is licensed to practice
                  in the states of Tennessee. She believes that patient
                  education and advocating for patients are two of the most
                  important aspects of care that she provides which is a key
                  factor in keeping her patients safe, happy, and healthy. Her
                  goal is to help patients live a healthy and prosperous life.
                  She is married and has two sons. She likes crafting, watching
                  her son play football, volunteering at her church, and
                  spending time on the lake.
                </span>
                <p className="mb-30">
                  She is excited to get to know her patients and be able to help
                  the community.
                </p>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6">
                    <div className="it-about-2-icon-box style-1">
                      <span>
                        <i className="flaticon-counseling"></i>
                      </span>
                      <h5>Online Counseling</h5>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6">
                    <div className="it-about-2-icon-box style-2">
                      <span>
                        <i className="flaticon-artificial-intelligence"></i>
                      </span>
                      <h5>Group Therapy</h5>
                    </div>
                  </div>
                </div>
                <div className="it-about-2-tel-wrap mt-30 flex-wrap d-sm-flex align-items-center">
                  <Link
                    className="it-btn-theme grey-bg mr-55"
                    to="/service-details"
                  >
                    <Button btnText="Our Counseling" />
                  </Link>
                  <div className="it-about-2-tel-box d-flex align-items-center">
                    <div className="it-about-2-tel-icon">
                      <span>
                        <i className="flaticon-message"></i>
                      </span>
                    </div>
                    <div className="it-about-2-tel-text">
                      <span>Emergency</span>
                      <a className="hover-anim" href="tel:99012356987">
                        (+99) 012356987
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
